namespace GeniuzPOS.Administration {
    export interface UserListRequest extends Serenity.ListRequest {
    }
}
